import { ClickableMap } from "components/page-components/Ausschreibungsdienste/landingpage-components/utils"
import { CaretIcon } from "components/page-components/Icons/small"

import { Link, graphql, useStaticQuery } from "gatsby"

import React, { useState } from "react"
import { startCase } from "lodash"

export const NeighbouringHits = ({ neighbours, long_value, lat_value }) => {
  const data = useStaticQuery(graphql`{
  neighbouringHits: allAdRegionLp(sort: {slug: ASC}) {
    nodes {
      slug
      number_of_notices
    }
  }
}`)

  const [current_map_position, set_current_map_position] = useState({
    lat: lat_value,
    lng: long_value,
  })
  const decrease_lng = () =>
    set_current_map_position({
      ...current_map_position,
      lng: Math.max(0, current_map_position.lng - 0.4),
    })
  const increase_lng = () =>
    set_current_map_position({
      ...current_map_position,
      lng: Math.min(1, current_map_position.lng + 0.4),
    })
  const decrease_lat = () =>
    set_current_map_position({
      ...current_map_position,
      lat: Math.max(0, current_map_position.lat - 0.3),
    })
  const increase_lat = () =>
    set_current_map_position({
      ...current_map_position,
      lat: Math.min(1, current_map_position.lat + 0.3),
    })

  return (
    <div className="section">
      <div className="container">
        <div className="columns is-centered is-vcentered is-variable is-8 ">
          <div className="column is-6">
            <p className="title is-3 is-spaced">
              Aufträge aus benachbarten Bundesländern
            </p>

            <div className="content my-6">
              <p className="has-text-weight-bold">Benachbarte Bundesländer:</p>
              <ul className="is-ausschreibungsdienste">
                {neighbours.map((neighbour, index) => {
                  const neighbours_name_readable = startCase(neighbour)
                    .split(" ")
                    .join("-")
                  const neighbours_hit_data = data.neighbouringHits.nodes.find(
                    ({ slug }) => slug === neighbour
                  )?.number_of_notices
                  return (
                    <li key={`neighbour-${index}`} className="my-4">
                      {neighbours_name_readable}:{" "}
                      <Link
                        className="link"
                        to={`/ausschreibungsdienste/ausschreibungen/region/${neighbour}`}
                      >
                        <span className="has-text-weight-bold has-text-auftragsvolumendunkelgruen">
                          {neighbours_hit_data}
                        </span>{" "}
                        laufende Ausschreibungen
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </div>
            <Link
              className="button is-mitternachtsblau is-outlined"
              to={"/ausschreibungsdienste/ausschreibungen/region"}
            >
              Alle Regionen
            </Link>
          </div>
          <div className="column px-0">
            <div className="columns is-gapless is-mobile">
              <div className="column is-flex is-flex-direction-column">
                <ClickableMap
                  {...{
                    viewBox: `${current_map_position.lng * 50} ${
                      current_map_position.lat * 375
                    } 550 425`,
                    border: "6px solid #034055",
                  }}
                />
                <div className="mx-auto my-2">
                  <button
                    className="button is-tertiary is-small"
                    disabled={current_map_position.lng === 0}
                    onClick={decrease_lng}
                  >
                    <CaretIcon
                      {...{
                        size: 1,
                        color: "#034055",
                        rotation: "left",
                      }}
                    />
                  </button>
                  <button
                    className="button is-tertiary is-small"
                    disabled={current_map_position.lng === 1}
                    onClick={increase_lng}
                  >
                    <CaretIcon
                      {...{
                        size: 1,
                        color: "#034055",
                        rotation: "right",
                      }}
                    />
                  </button>
                </div>
              </div>
              <div className="column is-narrow is-flex">
                <div
                  className="my-auto is-flex is-flex-direction-column mx-2"
                  style={{ paddingBottom: 46 }}
                >
                  <button
                    className="button is-tertiary is-small"
                    disabled={current_map_position.lat === 0}
                    onClick={decrease_lat}
                  >
                    <CaretIcon
                      {...{
                        size: 1,
                        color: "#034055",
                        rotation: "up",
                      }}
                    />
                  </button>

                  <button
                    className="button is-tertiary is-small"
                    disabled={current_map_position.lat === 1}
                    onClick={increase_lat}
                  >
                    <CaretIcon
                      {...{
                        size: 1,
                        color: "#034055",
                        rotation: "down",
                      }}
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
